import { Grid } from '../../../../base';
import PersonalInfoCard from '../../PersonalInfoCard';
import EvaluatedSkills from '../../EvaluatedSkills';
import AIInsights from '../../AIInsights';
import { IJobApplication } from '../../../../common';
import {
    StyledContainer,
    StyledEvaluatedSkillsSection,
} from './StepInitialTemplate.styles';
import InterviewDetails from '../../InterviewDetails';
import CandidateStatus from '../../CandidateStatus';

interface StepInitialTemplateProps {
    jobApplicationData: IJobApplication;
}

const StepInitialTemplate = (props: StepInitialTemplateProps) => {
    const { jobApplicationData } = props;

    return (
        <StyledContainer container spacing={2}>
            <Grid
                container
                flexDirection={'column'}
                item
                xs={12}
                lg={7}
                spacing={2}
            >
                <Grid container item xs={12} spacing={2}>
                    <Grid item xs={5}>
                        <PersonalInfoCard
                            jobApplication={jobApplicationData}
                        />
                    </Grid>
                    <Grid item xs={7}>
                        <CandidateStatus
                            jobApplication={jobApplicationData}
                            isLegacy={jobApplicationData.isLegacy}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <InterviewDetails
                        key={jobApplicationData.id}
                        jobApplication={jobApplicationData}
                        isLegacy={jobApplicationData.isLegacy}
                    />
                </Grid>
            </Grid>
            <Grid
                item
                xs={12}
                lg={5}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <StyledEvaluatedSkillsSection item>
                    <EvaluatedSkills
                        isEditable
                        requirements={jobApplicationData?.requirements}
                        questionAnswers={jobApplicationData?.questionAnswers}
                        isLegacy={jobApplicationData.isLegacy}
                    />
                </StyledEvaluatedSkillsSection>
                <Grid item xs={12}>
                    <AIInsights
                        insights={jobApplicationData?.insights}
                        isLegacy={jobApplicationData.isLegacy}
                    />
                </Grid>
            </Grid>
        </StyledContainer>
    );
};

export default StepInitialTemplate;
